import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { GestionUsuariosService } from 'src/app/dashboard/services/gestion-usuarios.service';
import { ApiService } from 'src/app/shared/services/api.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { environment } from 'src/environments/environment.prod';
import { CustomValidators } from 'src/app/shared/custom-validator/custom-validator.component';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.css']
})

export class AddUserComponent implements OnInit {
  validatingForm: FormGroup;

  constructor(private usuariosService: GestionUsuariosService, private apiService: ApiService, private auth: AuthService, private router: Router, private toastr: ToastrService, private translate: TranslateService) { }

  ngOnInit() {
    let language = this.auth.getLanguage();
    if (language == "" || language == null) {
      language = 'es';
    }
    this.translate.setDefaultLang(language);
    this.validatingForm = new FormGroup({
      signupFormModalId: new FormControl('', [
        Validators.required,
        Validators.pattern(/^(?:[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}|[a-zA-Z0-9_-]{1,100})$/),
        //CustomValidators.secureInput
      ]),

      signupFormModalEmail: new FormControl('', [
        Validators.email,
        Validators.required,
        Validators.maxLength(250),
        Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{1,100}$/)
      ]),
      signupFormModalName: new FormControl('', [
        Validators.required,
        // Validators.pattern(/^[a-zA-Z0-9_-]{1,100}$/),
        Validators.pattern(/^[a-zA-Z0-9 áéíóúÁÉÍÓÚñÑ.,()\-_\[\]\/"']{1,100}$/),
        CustomValidators.secureInput
      ]),
      signupFormModalSurname: new FormControl('', [
        Validators.required,
        // Validators.pattern(/^[a-zA-Z0-9_-]{1,100}$/),
        Validators.pattern(/^[a-zA-Z0-9 áéíóúÁÉÍÓÚñÑ.,()\-_\[\]\/"']{1,150}$/),
        CustomValidators.secureInput
      ])
    });
  }

  get signupFormModalName() {
    return this.validatingForm.get('signupFormModalName');
  }

  get signupFormModalId() {
    return this.validatingForm.get('signupFormModalId');
  }

  get signupFormModalSurname() {
    return this.validatingForm.get('signupFormModalSurname');
  }

  get signupFormModalEmail() {
    return this.validatingForm.get('signupFormModalEmail');
  }

  /**
   * Function to add new user and send email with the instructions to create password
   */
  addUser() {
    if (this.validatingForm.invalid) {
      this.toastr.error(this.translate.instant('texto_815'), this.translate.instant('texto_813'));
      return;
    }
    let $clau = false;
    let clausulas_correo = localStorage.getItem("clausulas_correo");
    if (clausulas_correo == '1') {
      $clau = true;
    }

    //Add user but without password
    this.usuariosService.addUser(this.signupFormModalId.value, this.signupFormModalEmail.value, this.signupFormModalName.value, this.signupFormModalSurname.value, this.auth.getSociedad()).subscribe(
      res => {
        if ((res as any).success === true) {
          this.toastr.success(this.translate.instant('texto_311'), this.translate.instant('texto_312'));
          //if user is added successful, send an email with the instructions to create a password with function "Recuperar contraseña"
          let url = environment.base + "/login";
          /* Message content
          Estimado/a Uusario
          Te comunicamos que has sido dado de alta en el Canal Ético. Para activar tu cuenta y establecer tu contraseña, por favor sigue estos pasos:
          1. Visita el apartado Recuperar contraseña en el Canal Ético, ubicado en la pantalla Iniciar Sesión
          2. Ingresa tu dirección de correo electrónico registrada: dirección
          3. Sigue las instrucciones para asignar una nueva contraseña.
          Es importante que realices este proceso lo antes posible para asegurarte de que tu cuenta esté completamente activada y lista para su uso.
          */
          let message = this.translate.instant('texto_576') + " " + this.signupFormModalName.value + " " + this.signupFormModalSurname.value + "<br>" +
            this.translate.instant('texto_577') + "<br><br>" +
            "1. " + this.translate.instant('texto_578') + "<br>" +
            "2. " + this.translate.instant('texto_579') + " " + this.signupFormModalEmail.value + "<br>" +
            "3. " + this.translate.instant('texto_775') + "<br><br>" +
            this.translate.instant('texto_776');

          this.apiService.sendEmail(this.signupFormModalEmail.value, this.translate.instant('texto_580'), message, url, $clau, this.translate.instant('texto_580'), 'gestor').subscribe(
            res => {
              if (res == 200) {
                this.toastr.success(this.translate.instant('texto_194'), this.translate.instant('texto_195'));
              } else {
                this.toastr.error(this.translate.instant('texto_193'), this.translate.instant('texto_195'));
              }
            });
        } else {
          this.toastr.error(this.translate.instant('texto_313'), this.translate.instant('texto_312'));
        }
        this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/dashboard/layout/usuarios']);
        });
      }, err => {
        if (err.status === 409) {
          this.toastr.error(this.translate.instant('texto_313'), this.translate.instant('texto_813'));
        } else {
          this.toastr.error(this.translate.instant('texto_313'), this.translate.instant('texto_813'));
        }
      });
  }

  makeKey(length) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

}
